import { useEmailContext } from '../../../../../../contexts/EmailContext';
import { Box } from '@coolblue-development/freddy';

const TemplatePreview = (): JSX.Element | null => {
  const { templateHtml } = useEmailContext();

  if (!templateHtml) return null;
  return <Box dangerouslySetInnerHTML={{ __html: templateHtml }} />;
};

export default TemplatePreview;
